import * as fabric from 'office-ui-fabric-react';
import PageHeader from '../../../../components/layout/PageHeader';
import GroupsPage from './groups/GroupsPage';
import ServicePage from './services/ServicesPage';

const ServiceGroupPage = () => {
    return (
        <div className="ms-Grid" dir="ltr">
            <PageHeader text="Paslaugos ir jų grupės" />
            <div className="ms-Grid-row" style={{ paddingTop: '10px' }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <fabric.Pivot id="serviceGroupPivot" style={{ textAlign: 'center' }}>
                        <fabric.PivotItem headerText="Paslaugos">
                            <ServicePage />
                        </fabric.PivotItem>
                        <fabric.PivotItem headerText="Grupės">
                            <GroupsPage />
                        </fabric.PivotItem>
                    </fabric.Pivot>
                </div>
            </div>
        </div>
    );
};

export default ServiceGroupPage;
